// extracted by mini-css-extract-plugin
export default {"statusRow":"WhatsAppSetup_statusRow__BSiap"};